var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._g({staticClass:"check",model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }